export default [
  { key: 'started_time', label: 'Started', type: 'datetime' },
  { key: 'finished_time', label: 'Finished', type: 'datetime' },
  { key: 'items_total', label: 'Total' },
  { key: 'items_saved', label: 'Saved' },
  { key: 'items_skipped', label: 'Skipped' },
  { key: 'items_failed', label: 'Failed' },
  { key: 'errors', label: 'Errors' },
]